<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-header" qid="client-view-page-title">
        <h4>{{ client.name }}</h4>
        <div class="mb-2">
          <span v-if="getGuide('partition')">
            <GuideButton :guide="getGuide('partition')"></GuideButton>
          </span>
        </div>
      </div>
      <div class="card-body">
        <div class="content-view-body">
          <div>
            <p class="text-dark">
              {{ $t('administration.partitions.create.cvr_label') }}
            </p>
            <hr>
            <p qid="clients-cvr">{{ client.cvr }}</p>
            <br>
          </div>
          <div>
            <p class="text-dark">
              {{ $t('administration.partitions.create.street_label') }}
            </p>
            <hr>
            <p qid="clients-street">{{ client.street }}</p>
            <br>
          </div>
          <div>
            <p class="text-dark">
              {{ $t('administration.partitions.create.city_label') }}
            </p>
            <hr>
            <p qid="clients-city">{{ client.city }}</p>
            <br>
          </div>
          <div>
            <p class="text-dark">
              {{ $t('administration.partitions.create.postcode_label') }}
            </p>
            <hr>
            <p qid="clients-postcode">{{ client.postcode }}</p>
            <br>
          </div>
          <div>
            <p class="text-dark">
              {{ $t('administration.partitions.create.country_label') }}
            </p>
            <hr>
            <p qid="clients-country">{{ client.country}}</p>
            <br>
          </div>
          <div>
            <p class="text-dark">
              {{ $t('partitions.date_created_label') }}
            </p>
            <hr>
            <p qid="clients-date-created">{{ client.created_at | formatDate }}</p>
            <br>
          </div>
          <div>
            <p class="text-dark">
              {{ $t('table.last_updated') }}
            </p>
            <hr>
            <p qid="clients-date-updated">{{ client.updated_at | formatDate }}</p>
            <br>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js'
import GuideButton from '@/components/guide/GuideButton.vue';


export default {
  name: 'ClientView',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('maintenance.title'),
          to: '/maintenance'
        },
        {
          text: this.$t('maintenance.partitions.title'),
          to: '/maintenance/partitions'
        }
      ],
      client: {},
      myGuides: [],
    }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    }
  },
  components: {
    GuideButton
  },
  methods: {
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.type == 'Maintenance' && object.enabled
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Maintenance',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    }
  },
  created () {

    let self = this;
    this.loadGuides('partition');

    piincHttp.get('partitions/' + this.$route.params.slug, { params:
      {
        client: this.getClient.slug
      }
    }).then(function(response) {
      self.client = response.data;
      // Push clients name in breadcrumb array
      self.breadcrumbItems.push({text: self.client.name, active: true});
    }, function() {

    });
  }
}
</script>
